import React, { useState } from "react";
import Skeleton from "../loaders/Skeleton";

const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-12 w-12"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export default function ImagePreview({ src }: { src: string }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className="flex h-full w-full items-center justify-center">
      {isLoading && (
        <div className="flex flex-col items-center">
          <Skeleton className="h-48 w-48" />
          <p className="mt-2 text-sm text-gray-500">Loading thumbnail...</p>
        </div>
      )}
      {hasError && (
        <div className="flex flex-col items-center text-red-500">
          <ErrorIcon />
          <p className="mt-2 text-sm">Failed to load image</p>
        </div>
      )}
      <img
        src={src}
        alt="Image Preview"
        className={`h-auto max-h-[600px] w-auto max-w-[1067px] ${
          isLoading || hasError ? "hidden" : ""
        }`}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    </div>
  );
}
